import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import QuestionListComponent from './QuestionListComponent';
import Details from '@mui/icons-material/PlaylistAdd';
import Search from '@mui/icons-material/Search';
import { Pagination, IconButton, Card, TextField } from '@totalsoft/rocket-ui';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const QuestionListCard = ({
  questions,
  questionTypes,
  onSave,
  validation,
  isReadOnly,
  onRowsPerPageChange,
  onPageChange,
  onRefresh,
  pagination,
  totalCount,
  fullTextFilter,
  onChangeFilterValue,
  onAddNewQuestion,
  rowsPerPageOptions,
  onPropertyChanged,
  getIndexInFilteredList,
  onAddNewQuestionDetailRow,
  onDetailPropertyChanged,
  onDeleteQuestionDetailRow,
  onExpandChange,
  onDelete
}) => {
  const { t } = useTranslation();
  const onTextFilterChanged = detailValue => {
    onChangeFilterValue(detailValue);
  };

  const resetFilters = _ => onTextFilterChanged('');

  return (
    <Card
      icon={Details}
      iconColor='primary'
      title={t('Questionnaire.Questions')}
      subheader={
        <TextField
          id={'documentVerificationList_filters_fullText'}
          name='fullTextFilter'
          value={fullTextFilter}
          onChange={event => onTextFilterChanged(event)}
          placeholder={t('Cauta dupa codul sau textul intrebarii')}
          startAdornment={<Search />}
          endAdornment={
            <IconButton
              color='transparent'
              type='cancel'
              fontSize='medium'
              tooltip={t('Tooltips.ResetFilters')}
              onClick={resetFilters}
              id={'documentVerificationList_filters_resetBtn'}
            />
          }
        />
      }
      actions={
        <IconButton
          color='transparent'
          type='add'
          fontSize='medium'
          tooltip={t('Tooltips.Add')}
          onClick={onAddNewQuestion}
          disabled={isReadOnly}
        />
      }
      footer={
        <Pagination
          loading={false}
          count={totalCount}
          pageSize={pagination.pageSize}
          page={pagination.page}
          rowsPerPageOptions={rowsPerPageOptions}
          onRowsPerPageChange={onRowsPerPageChange}
          onPageChange={onPageChange}
          onRefresh={onRefresh}
        />
      }
    >
      <CardNoResultsWrapper content={questions}>
        <QuestionListComponent
          questions={questions}
          questionTypes={questionTypes}
          onSave={onSave}
          validation={validation}
          isReadOnly={isReadOnly}
          onPropertyChanged={onPropertyChanged}
          getIndexInFilteredList={getIndexInFilteredList}
          onAddNewQuestionDetailRow={onAddNewQuestionDetailRow}
          onDetailPropertyChanged={onDetailPropertyChanged}
          onDeleteQuestionDetailRow={onDeleteQuestionDetailRow}
          onExpandChange={onExpandChange}
          onDelete={onDelete}
        />
      </CardNoResultsWrapper>
    </Card>
  );
};

QuestionListCard.propTypes = {
  questions: PropTypes.array.isRequired,
  questionTypes: PropTypes.array,
  onAddNewQuestion: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object,
  isReadOnly: PropTypes.bool,
  onPropertyChanged: PropTypes.func.isRequired,
  getIndexInFilteredList: PropTypes.func.isRequired,
  onAddNewQuestionDetailRow: PropTypes.func.isRequired,
  onDetailPropertyChanged: PropTypes.func.isRequired,
  onDeleteQuestionDetailRow: PropTypes.func.isRequired,
  onExpandChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  //filter
  onRowsPerPageChange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  fullTextFilter: PropTypes.string.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired
};

export default QuestionListCard;
